import { render, staticRenderFns } from "./PillsLayout.vue?vue&type=template&id=128ac0c8&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PillsLayout.vue"
export default component.exports